// eslint-disable-next-line no-unused-vars
declare const gtag: (command: 'event', eventName: string, eventParams?: Record<string, any>) => void

export const GTMTrack = (
  eventName: string,
  value?: Record<string, any>
) => {
  gtag('event', eventName, value)
}
export const dataCollect = (
  eventName: string,
  value?: Record<string, any>
) => {
  if (process.env.NODE_ENV !== "development") {
    GTMTrack(eventName, value)
  } else {
    console.log(`eventName: ${eventName}, value: ${value}`)
  }
}